import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

import { connect } from 'react-redux';
import { customSwal } from '../../../theme';

import SpinWrapper from './../../common/Spin';
import { message, Empty } from 'antd';

// ROUTES
import {
  ADD_TRAINER_URL,
  ADD_USER_URL
} from '../../../constants/navigationRoutes';

// COMMON COMPONENTS
import TrainerList from '../../common/List/TrainerList';
import Button from '../../common/Button';
import Toggle from '../../common/Toggle';
import * as T from '../../common/Typography';
import Layout from '../../Layouts';

// STYLING
import { Wrapper, HeaderSection, HeaderNumber } from './TrainerListPage.style';

class TrainerListPage extends Component {
  state = {
    trainers: [],
    localLeads: [],
    loaded: false,
    toggle: 'left',
    showDeleteModal: false
  };

  refresh() {
    const { role } = this.props;
    if (role === 'admin') {
      this.adminFetchData();
    } else {
      this.localLeadFetchData();
    }
  }

  componentDidMount() {
    this.refresh();
  }

  localLeadFetchData = () => {
    axios
      .get('/api/users/my-trainers')
      .then(response => {
        this.setState({
          trainers: response.data.trainerList,
          loaded: true
        });
      })
      .catch(err => {
        message.error(`Error!, ${err?.response?.data?.error}`);
      });
  };

  adminFetchData = () => {
    axios
      .get('/api/users/admin/trainers-and-leads')
      .then(response => {
        this.setState({
          trainers: response.data.trainerList,
          localLeads: response.data.localLeadList,
          loaded: true
        });
      })
      .catch(err => message.error(`Error!, ${err?.response?.data?.error}`));
  };

  clickToggle = direction => {
    this.setState({ toggle: direction });
  };

  deleteUser = async trainerId => {
    const { userId: localLeadId } = this.props;
    try {
      await axios.delete(`/api/local-lead/${localLeadId}/trainer/${trainerId}`);
      this.localLeadFetchData();
    } catch (err) {
      message.error(`Error!, Internal server Error`);
    }
  };

  showDeleteConfirm = trainerId => {
    Swal.fire({
      title: 'Are you sure you want to delete this trainer?',
      text: "You won't be able to revert this!",
      confirmButtonText: 'Yes',
      showCancelButton: true,
      cancelButtonText: 'No',
      ...customSwal
    }).then(willDelete => {
      if (willDelete.value) {
        this.deleteUser(trainerId);
      }
    });
  };

  render() {
    const { trainers, localLeads, loaded, toggle } = this.state;

    const { role } = this.props;

    const trainersToShow =
      toggle === 'left'
        ? trainers.filter(({ archived }) => !archived)
        : toggle === 'middle'
        ? localLeads.filter(({ archived }) => !archived)
        : [...trainers, ...localLeads].filter(({ archived }) => archived);

    const count = trainersToShow.length;

    const subject =
      toggle === 'left'
        ? 'Trainers'
        : toggle === 'middle'
        ? 'Local Leads'
        : 'Archived';

    if (!loaded) {
      return <SpinWrapper />;
    }
    return (
      <Layout>
        <Wrapper>
          <T.H1 mb={5}>Trainers</T.H1>
          <HeaderSection>
            <T.P weight={700} color="gray">
              {`Total ${subject}:`}
            </T.P>
            <HeaderNumber>{count}</HeaderNumber>
            {role === 'admin' && (
              <>
                <Link to={ADD_USER_URL}>
                  <Button label="Add New User" type="tertiary" width="146px" />
                </Link>
                <Toggle
                  style={{ maxWidth: '600px' }}
                  leftText="trainers"
                  midText="local leads"
                  rightText="archived"
                  selected={toggle}
                  onClick={this.clickToggle}
                  mt={5}
                />
              </>
            )}
            {role === 'localLead' && (
              <Link to={ADD_TRAINER_URL}>
                <Button label="Add Trainer" type="tertiary" width="146px" />
              </Link>
            )}
          </HeaderSection>
          <div style={{ maxWidth: '650px' }}>
            {count ? (
              <TrainerList
                dataList={trainersToShow}
                role={role}
                deleteUser={this.showDeleteConfirm}
                reload={() => this.refresh()}
              />
            ) : (
              <Empty description={`No ${subject}`} />
            )}
          </div>
        </Wrapper>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return { userId: state.auth.userId };
};

export default connect(mapStateToProps)(TrainerListPage);
